import React, { useState, useEffect } from 'react';
import Logo from '../../assets/images/qr-code.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard, faShareAlt } from '@fortawesome/free-solid-svg-icons';
import { WhatsappShareButton, WhatsappIcon, EmailShareButton, EmailIcon } from "react-share";
import { getAmbassadorDetail } from '../../actions/AmbassadorActions'

// const shareUrl = 'https://www.allenoverseas.com/'
const title = 'Allen overseas'

const ViewQr = (props) => {
    const [show, setShow] = useState();
    const [showQrShare, setShowQrShare] = useState();
    const [shareLink, setShareLink] = useState(undefined);
    const [ambDetail, setAmbDetail] = useState(undefined);
    const [showClipboard,setShowClipboard] = useState(false);

    useEffect(async () => {
        const ambRes = await getAmbassadorDetail()
        if (ambRes.data !==undefined) {
            setAmbDetail(ambRes.data)
            const {slug } = ambRes.data
            let link = `${process.env.REACT_APP_WEB_URL}/amb-referral-register?amb=${slug}`
            setShareLink(link)
        }
    }, [])
    return (
        <div className='row align-items-start'>
            <div className='col-md-7 viewQr_code_contain pt-4'>
                {/* <h4 className='ms-0'>Lorem ipsum dolor sit amet, consectetur adipiscing elit</h4>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip</p> */}
                <div className='w-100 d-flex align-items-center mt-4 position-relative'>
                    {shareLink !== undefined && <input type="text" className='form-control' name='shareLink' value={shareLink} />}

                    <button className={`btn-primary py-2 border-0 px-3 ${showClipboard && 'copy_linkBtn'}`} 
                    onClick={() => navigator.clipboard.writeText(shareLink).then(() => { setShowClipboard(true); setTimeout(() => { setShowClipboard(false); }, 1500)}, () => { setShowClipboard(false)})}>
                    <FontAwesomeIcon icon={faClipboard} /></button>

                    <button className='btn-primary border-0 py-2 px-3 ' onClick={() => setShow(!show)}><FontAwesomeIcon icon={faShareAlt} /></button>
                    {show ?
                        <div className='d-flex ms-2 wrap_icons'>
                            <WhatsappShareButton
                                title={`Hey Buddy! Are you ready to take on the challenge for TALLENTEX 2023?             
I am inviting you to take part in the biggest talent encouragement cum scholarship exam with my unique referral link.
                                                                
Click on the below link to register for TALLENTEX Overseas 2023 and let’s invite our friends to the competition.
                                `}
                                 separator=""
                                 url={`
${shareLink}`}
                                className="me-2"
                                windowWidth={990}
                                windowHeight={720}
                            >
                                <WhatsappIcon size={32} round />
                            </WhatsappShareButton >

                            <EmailShareButton 
                            subject="Hey Buddy! Are you ready to take on the challenge for TALLENTEX 2023?" 
                            body={`I am inviting you to take part in the biggest talent encouragement cum scholarship exam with my unique referral link.

Click on the below link to register for TALLENTEX Overseas 2023 and let’s invite our friends to the competition.
`
                        }
                            separator="" 
                            url={`

 ${shareLink}

 `} >
                                <EmailIcon size={"2rem"} round />
                            </EmailShareButton>
                        </div>
                        : ''
                    }


                </div>
            </div>
            <div className='col-md-5 d-flex viewQr_code_contain justify-content-center position-relative'>
                {ambDetail !== undefined && <img src={`https://admin.allenoverseas.com/2023-2024/qrcode/${ambDetail.qrcode}`} className="w-50 img-fluid" alt="Qr code" />}
                <div className='share_qr_codeContain ms-2'>
                    <button className='btn-primary share_qr_codeBtn border-0 py-2 px-3 mt-3' onClick={() => setShowQrShare(!showQrShare)}><FontAwesomeIcon icon={faShareAlt} /></button>
                    {showQrShare ?
                        <div className='mt-2 d-flex flex-column wrap_icons'>
                            <WhatsappShareButton
                                title={`Hey Buddy! Are you ready to take on the challenge for TALLENTEX 2023?             
I am inviting you to take part in the biggest talent encouragement cum scholarship exam with my unique referral link.
                                
Click on the below link to register for TALLENTEX Overseas 2023 and let’s invite our friends to the competition.
`}
                                                               separator=""
 url={`
${shareLink}`}
                                className="mb-2"
                                windowWidth={990}
                                windowHeight={720}
                            >
                                <WhatsappIcon size={32} round />
                            </WhatsappShareButton>

                            <EmailShareButton 
                            subject="Hey Buddy! Are you ready to take on the challenge for TALLENTEX 2023?" 
                            body={`I am inviting you to take part in the biggest talent encouragement cum scholarship exam with my unique referral link.

Click on the below link to register for TALLENTEX Overseas 2023 and let’s invite our friends to the competition.
`
                        }
                            separator="" 
                            url={`

 ${shareLink}

 `} >
                                <EmailIcon size={"2rem"} round />
                            </EmailShareButton>
                        </div>
                        : ''
                    }
                </div>

            </div>

        </div>
    )
}

export default ViewQr;